module.exports = __webpack_public_path__ + "img/joker_1248.c454c8df.png";